import PrintersFirmwareModal from './printers-firmware-modal.connect'

export default PrintersFirmwareModal